import { gql } from '@zenbusiness/application-commons-graphql';

export const PRODUCT_CARDS_QUERY = gql`
  query ProductCards($filter: ProductCardsFilter!, $experiment: ProductCardsExperiment) {
    productCards(filter: $filter, experiment: $experiment) {
      cards {
        categories {
          label
          state
        }
        description
        estimate
        imageUrl
        partnerImageUrl
        primaryCta {
          modalName
          url
          label
        }
        product {
          name
          pricing {
            amount
            formattedPricePerInterval
          }
          service
          uuid
        }
        secondaryCta {
          label
          modalName
          url
        }
        status {
          state
          label
        }
        title
      }
      categories {
        label
        state
      }
    }
  }
`;
